<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-area
                class="mb-2"
                type="fieldset"
                title="ATRIBUIR PARA AS JORNADAS SELECIONADAS"
            >
                <rkm-form ref="RkmForm">
                    <rkm-row class="flex-nowrap">

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Inicial"
                                v-model="jornada.horaInicial"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Final"
                                v-model="jornada.horaFim"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-select
                                :options="form.tipos"
                                label="Tipo de Jornada"
                                show-default-option
                                text-field="nome"
                                v-model="jornada.tipoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Número de vagas"
                                v-model="jornada.vagas"
                            />
                        </rkm-col>


                        <rkm-col cols="auto">

                            <rkm-button
                                :label="false"
                                @click.stop="atribuir()"
                                color="primary"
                                :disabled="handleDisabled()"
                            >
                                Atribuir
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click.stop="resetForm"
                                color="secondary"
                                :disabled="(!jornada.horaInicial && !jornada.horaFim && !jornada.vagas && !jornada.tipoId)"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Enuns.
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'

export default {
    data:() => ({
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            tipoId: null,
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
        },
        enums: {
            tipoJornada
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        atribuir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    if(this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0){

                        let msg = ''

                        this.model.jornadasNotSave.map((item, index) => {

                            if(item.selecionado){

                                const existeJornada = this.model.jornadasNotSave.find((j, i) => {

                                    const horaInicial = moment(item.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                    const horaFinal = moment(item.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                    return index !== i && moment(horaInicial).isBetween(
                                        moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                        moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                    )
                                    || index !== i && moment(horaFinal).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                    || index !== i && moment(horaInicial).isSame(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i && moment(horaFinal).isSame(
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i && moment(
                                            this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')
                                        )
                                        .isBefore(
                                            j.data.concat(' ', j.horaInicial),
                                        )
                                    && moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm'))
                                        .isAfter(
                                            j.data.concat(' ', j.horaFim),
                                        )
                                })

                                const verificaData = [item.data]

                                if(existeJornada){

                                    for( let i = 0; i < verificaData.length; i++) {

                                        msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário.')
                                    }
                                }

                                var horaInicial = this.jornada.horaInicial

                                if (!horaInicial) {
                                    horaInicial = item.horaInicial
                                }

                                var horaFim = this.jornada.horaFim

                                if (!horaFim) {
                                    horaFim = item.horaFim
                                }

                                var vagas = this.jornada.vagas

                                if (!vagas) {
                                    vagas = item.vagas
                                }

                                var tipoId = this.jornada.tipoId

                                if (!tipoId) {
                                    tipoId = item.tipoId
                                }

                                if(!existeJornada){

                                    var timeFim = horaFim.substr(0, 5)
                                    horaInicial = horaInicial.substr(0, 5)

                                    var inicioFim = horaInicial.split(':')
                                    var finalFim = timeFim.split(':')

                                    var inicioTratadoF = parseInt(inicioFim[0]* 60) + parseInt(inicioFim[1])
                                    var finalTratadoF = parseInt(finalFim[0]* 60) + parseInt(finalFim[1])

                                    var diferencaMinutosF = finalTratadoF - inicioTratadoF

                                    var totalSegundosF = diferencaMinutosF * 60

                                    var verificaSegundoF = totalSegundosF / vagas

                                    if (this.jornada.tipoId == this.enums.tipoJornada.FIXA) {

                                        if( verificaSegundoF < 60 && horaInicial != timeFim){

                                            this.showValidationNotification("O atendimento deve ter ao menos um minuto")

                                            return
                                        }

                                    } else {

                                        if( verificaSegundoF < 60 ){

                                            this.showValidationNotification("O atendimento deve ter ao menos um minuto")

                                            return
                                        }
                                    }

                                    if(vagas && horaInicial && timeFim){

                                        item.tempoAtendimento = diferencaMinutosF / vagas
                                    }

                                    if(this.jornada.horaInicial){

                                        item.horaInicial =  horaInicial
                                    }

                                    if(this.jornada.horaFim){

                                        item.horaFim =  timeFim
                                    }

                                    if(this.jornada.vagas){

                                        item.vagas = this.jornada.vagas
                                    }

                                    if(this.jornada.tipoId){

                                        item.tipoId = this.jornada.tipoId
                                        item.tipoNome = this.form.tipos.find(s => s.id === this.jornada.tipoId).nome
                                    }
                                }
                            }
                        })

                        this.mensagemConflito(msg)

                        this.resetForm()

                        this.$emit('getCalendar')

                    } else {

                        let msg = ''

                        this.model.jornadas.map((item, index) => {

                            if(item.selecionado){

                                const existeJornada = this.model.jornadas.find((j, i) => {

                                    const horaInicial = moment(item.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                    const horaFinal = moment(item.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                    return index !== i && moment(horaInicial).isBetween(
                                        moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                        moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                    )
                                    || index !== i && moment(horaFinal).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                    || index !== i && moment(horaInicial).isSame(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i && moment(horaFinal).isSame(
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i && moment(
                                            this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')
                                        )
                                        .isBefore(
                                            j.data.concat(' ', j.horaInicial),
                                        )
                                    && moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm'))
                                        .isAfter(
                                            j.data.concat(' ', j.horaFim),
                                        )
                                })

                                const verificaData = [item.data]

                                if(existeJornada){

                                    for( let i = 0; i < verificaData.length; i++) {

                                        msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário.')
                                    }
                                }

                                var horaInicial = this.jornada.horaInicial

                                if (!horaInicial) {
                                    horaInicial = item.horaInicial
                                }

                                var horaFim = this.jornada.horaFim

                                if (!horaFim) {
                                    horaFim = item.horaFim
                                }

                                var vagas = this.jornada.vagas

                                if (!vagas) {
                                    vagas = item.vagas
                                }

                                if(!existeJornada){

                                    var timeFim = horaFim.substr(0, 5)
                                    horaInicial = horaInicial.substr(0, 5)

                                    var inicioFim = horaInicial.split(':')
                                    var finalFim = timeFim.split(':')

                                    var inicioTratadoF = parseInt(inicioFim[0]* 60) + parseInt(inicioFim[1])
                                    var finalTratadoF = parseInt(finalFim[0]* 60) + parseInt(finalFim[1])

                                    var diferencaMinutosF = finalTratadoF - inicioTratadoF

                                    var totalSegundosF = diferencaMinutosF * 60

                                    var verificaSegundoF = totalSegundosF / vagas

                                    if( verificaSegundoF < 60 ){

                                        this.showValidationNotification("O atendimento deve ter ao menos um minuto")

                                        return
                                    }

                                    if(vagas && horaInicial && timeFim){

                                        item.tempoAtendimento = diferencaMinutosF / vagas
                                    }

                                    if(this.jornada.horaInicial){

                                        item.horaInicial =  horaInicial
                                    }

                                    if(this.jornada.horaFim){

                                        item.horaFim =  timeFim
                                    }

                                    if(this.jornada.vagas){

                                        item.vagas = this.jornada.vagas
                                    }
                                }
                            }
                        })

                        this.mensagemConflito(msg)

                        this.resetForm()

                        this.$emit('getCalendar')
                    }
                })
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível atribuir a jornada nas seguintes datas: '  + msg)
            }
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.tipoId = null
        },
        handleDisabled() {

            return this.jornada.horaInicial && this.selecionados
                || this.jornada.horaFim && this.selecionados
                || this.jornada.vagas && this.selecionados
                || this.jornada.tipoId && this.selecionados ? false : true
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number },
        selecionados: { type: Boolean }
    },
}
</script>